module.exports = __webpack_public_path__ + "img/ltkeaster-1x.fd7fe1b.jpg";